export default ({
	primaryLinks = [],
	featuredLink,
	socialMediaIcons,
	footerDisclaimer,
	footerCategories = [],
	copyright = `©2006-${new Date().getFullYear()} Lexus, a Division of Toyota Motor Sales, U.S.A., Inc. All information contained herein applies to U.S. vehicles only.`,
} = {}) => ({
	featuredLink,
	categories: footerCategories.map(({ ctaListTitle, ctaListItems = [] }) => ({
		title: ctaListTitle,
		links: ctaListItems,
	})),
	links: primaryLinks,
	social: socialMediaIcons,
	disclaimer: footerDisclaimer,
	copyright,
});
